// import { ExcelUtils } from "./ExcelUtils";
// import XLSX from "xlsx";

// export class ExcelGenerator {
//   constructor(options = ExcelUtils.getDefaultOptions()) {
//     this.options = options;
//   }

//   async generate() {
//     const { header, items, sheetName } = this.options;

//     // สร้าง header row
//     const headers = header.map((col) => col.label);

//     // สร้าง data rows
//     const rows = items.map((itemRow) =>
//       itemRow.map((item) => item.label)
//     );

//     let worksheetData = [];
//     this.insertSpaceRow(worksheetData)
//     // รวม header กับ data rows
//     worksheetData = [...worksheetData, headers, ...rows];
//     // สร้าง worksheet
//     const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

//     // กำหนดความกว้างของคอลัมน์
//     worksheet["!cols"] = header.map((col) => ({ wch: col.width }));

//     if (this.options.cell) {
//       for (const cellAddress in this.options.cell) {
//         const cellSettings = this.options.cell[cellAddress]
//         const cell = worksheet[cellAddress] || {};
//         await this.updateCell(cell, cellSettings)
//         worksheet[cellAddress] = cell
//       }
//     }
//     this.updateRange(worksheet)

//     // สร้าง workbook
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
//     return workbook;
//   }

//   updateRange(worksheet) {
//     try {
//       const cellKeys = Object.keys(worksheet).filter((key) => key[0] !== '!');
//       if (cellKeys.length > 0) {
//         const range = {
//           s: { r: Infinity, c: Infinity },
//           e: { r: -1, c: -1 },
//         };

//         cellKeys.forEach((key) => {
//           const cell = XLSX.utils.decode_cell(key);
//           range.s.r = Math.min(range.s.r, cell.r);
//           range.s.c = Math.min(range.s.c, cell.c);
//           range.e.r = Math.max(range.e.r, cell.r);
//           range.e.c = Math.max(range.e.c, cell.c);
//         });

//         worksheet['!ref'] = XLSX.utils.encode_range(range);
//       } else {
//         worksheet['!ref'] = 'A1:Z1000';
//       }
//     } catch (err) {
//       console.error(err)
//       worksheet['!ref'] = 'A1:Z1000';
//     }
//   }

//   insertSpaceRow(worksheetData) {

//     const startRow = this.options.headerOptions.startRow;
//     for (let i = 2; i <= startRow; i++) {
//       worksheetData.push([]);
//     }
//   }

//   async updateCell(cell, settings) {
//     try {
//       cell.v = settings.label;
//       cell.t = "s"
//     } catch (err) {
//       console.error(err)
//     }
//   }

// }


import { ExcelUtils } from "./ExcelUtils";
import XLSX from "xlsx";

export class ExcelGenerator {
  constructor(options = ExcelUtils.getDefaultOptions()) {
    this.options = options;
  }

  async generate() {
    const { header, items, sheetName } = this.options;

    // สร้าง header row
    const headers = header.map((col) => col.label);

    // สร้าง data rows
    const rows = items.map((itemRow) =>
      itemRow.map((item) => item.label)
    );

    let worksheetData = [];
    this.insertSpaceRow(worksheetData);
    // รวม header กับ data rows
    worksheetData = [...worksheetData, headers, ...rows];

    // สร้าง worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // กำหนดความกว้างของคอลัมน์
    worksheet["!cols"] = header.map((col) => ({ wch: col.width }));

    // กำหนด format ให้ cell และเพิ่ม hyperlink
    const startRow = this.options.headerOptions?.startRow || 0;
    items.forEach((itemRow, rowIndex) => {
      itemRow.forEach((item, colIndex) => {
        const actualRow = rowIndex + startRow;
        const cellAddr = XLSX.utils.encode_cell({ r: actualRow, c: colIndex });
        const cell = worksheet[cellAddr];
        
        if (cell) {
          // ถ้ามี hyperlink ให้เพิ่ม link
          if (item.hyperlink) {
            console.log('Adding hyperlink:', item.hyperlink, 'to cell:', cellAddr);
            cell.l = { 
              Target: item.hyperlink
            };
          }
          // กำหนด format ตัวเลข
          if (typeof cell.v === 'number') {
            cell.t = 'n';
            cell.z = '#,##0.00';
          } else if (!cell.t) {
            cell.t = 's';
          }
        }
      });
    });

    // กำหนด format ให้ cell อื่นๆ ที่เหลือ
    Object.keys(worksheet).forEach(cellAddr => {
      if(cellAddr[0] === '!') return;
      const cell = worksheet[cellAddr];
      if(!cell.l && typeof cell.v === 'number') {
        cell.t = 'n';
        cell.z = '#,##0.00';
      } else if (!cell.t) {
        cell.t = 's';
      }
    });

    this.updateRange(worksheet);

    // สร้าง workbook และเพิ่ม worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    return workbook;
  }

  updateRange(worksheet) {
    try {
      const cellKeys = Object.keys(worksheet).filter((key) => key[0] !== '!');
      if (cellKeys.length > 0) {
        const range = {
          s: { r: Infinity, c: Infinity },
          e: { r: -1, c: -1 },
        };

        cellKeys.forEach((key) => {
          const cell = XLSX.utils.decode_cell(key);
          range.s.r = Math.min(range.s.r, cell.r);
          range.s.c = Math.min(range.s.c, cell.c);
          range.e.r = Math.max(range.e.r, cell.r);
          range.e.c = Math.max(range.e.c, cell.c);
        });

        worksheet['!ref'] = XLSX.utils.encode_range(range);
      } else {
        worksheet['!ref'] = 'A1:Z1000';
      }
    } catch (err) {
      console.error(err);
      worksheet['!ref'] = 'A1:Z1000';
    }
  }

  insertSpaceRow(worksheetData) {
    const startRow = this.options.headerOptions?.startRow || 0;
    for (let i = 2; i <= startRow; i++) {
      worksheetData.push([]);
    }
  }
}